module.exports = __webpack_public_path__ + "img/use-coupon-icon.ec8c6731.png";